export default function SlButton({ children, className, ...rest }) {
   return (
      <button
         {...rest}
         className={`border-2 border-solid main-border main-blue-border-color rounded text-blue-500 font-bold p-1 px-3 ${className}`}
      >
         {children}
      </button>
   );
}
